export function arrayToMap(array: any[], key: string) {
    return array.reduce((map, item) => {
        map[item[key]] = item;
        return map;
    }, {});
}
